import React, { useEffect } from 'react';
import { Form, Select, Input, Alert, FormModal } from 'components';
import { Col, Row } from 'components';

interface RejectModalProps {
  form: any;
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  rejectionReasons: { label: string; value: string }[];
}

export const RejectModal: React.FC<RejectModalProps> = ({ form, open, onSubmit, onCancel, rejectionReasons }) => {
  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [form, open]);

  return (
    <FormModal
      form={form}
      width={400}
      title="Reject"
      open={open}
      onSubmit={onSubmit}
      onCancel={onCancel}
      disableOkBtn={false}
      okText="Reject"
      okButtonProps={{ danger: true }}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Form.Item
            name="rejectionReason"
            label="Reason*"
            rules={[{ required: true, message: 'Please select a rejection reason' }]}
          >
            <Select size={'large'} options={rejectionReasons} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="comments" label="Additional Information">
            <Input.TextArea rows={4} />
          </Form.Item>
        </Col>
      </Row>
      <Alert
        style={{ width: '100%', marginTop: 12 }}
        showIcon
        type="warning"
        message={`Rejecting a lead is final and cannot be undone. The lead will no longer be editable.`}
      />
    </FormModal>
  );
};
